module.exports = __webpack_public_path__ + "static/media/galerija_2014 (32).8285bc6c.jpg";